import theme from "../theme/dtvTheme";

export const BrandColor = Object.freeze({
  // white = theme.palette.common.white,
  uiblack: theme.palette.uiBlack.main,
  primary: theme.palette.primary.main,
  primarydark: theme.palette.primary.dark,
  primarylight: theme.palette.primary.light,
  secondary: theme.palette.secondary.main,
  secondarydark: theme.palette.secondary.dark,
  secondarylight: theme.palette.secondary.light,
  accentpolar: theme.palette.accentPolar.main,
  accentamethyst: theme.palette.accentAmethyst.main,
  accentamethystnew: theme.palette.accentAmethystNew.main,
  accentsun: theme.palette.accentSun.main,
  accentsolarflare: theme.palette.accentSolarFlare.main,
  package1: theme.palette.package1.main,
  package2: theme.palette.package2.main,
  package3: theme.palette.package3.main,
  package4: theme.palette.package4.main,
  backgrounddark: theme.palette.background.dark,
  backgrounddefault: theme.palette.background.default,
  error: theme.palette.error.main,
  surface: theme.palette.surface.main,
  onprimary: theme.palette.onPrimary.main,
  onsecondary: theme.palette.onSecondary.main,
  onbackground: theme.palette.onBackground.main,
  onsurface: theme.palette.onSurface.main,
  onerror: theme.palette.onError.main,
  textblack: theme.palette.textBlack.main,
  textwhite: theme.palette.textWhite.main,
  textblue: theme.palette.textBlue.main,
  black: theme.palette.black.main,
  white: theme.palette.white.main,
  red: theme.palette.red.main,
  green: theme.palette.green.main,
  blue: theme.palette.blue.main,
  yellow: theme.palette.yellow.main,
  magenta: theme.palette.magenta.main,
  aqua: theme.palette.aqua.main,
  functionalred: theme.palette.functionalRed.main,
  functionalgreen: theme.palette.functionalGreen.main,
  functionalorange: theme.palette.functionalOrange.main,
  containedbutton: theme.palette.containedButton.main,
  containedbuttonlabel: theme.palette.containedButtonLabel.main
});
